import { useParams } from "react-router-dom";
import {
  useForms,
  useMediaPdfFile,
  useUsedHours,
  useUser,
  useUserAppointments,
  useUserDiets,
} from "../../hooks";
import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu";
import DataTable from "../../components/dataTables/DataTable";
import { buildColDefs } from "../../components/dataTables/buildColDefs";
import { SpecificUserDetails, User } from "../../data-parsing/users/User";
import { UserDiet } from "../../data-parsing/users/UserDiet";
import {
  CreationForm,
  CreationFormInput,
  CreationFormTemplate,
} from "../../components/form/CreationForm";
import {
  SpecificUserAppointment,
  UserAppointment,
} from "../../data-parsing/userAppointment/UserAppointment";
import { TabbedContent } from "../../components/tabs/TabbedContent";
import { Breadcrumbs } from "../../components/breadCrumbs/Breadcrumbs";
import { useEffect, useRef, useState } from "react";
import moment from "moment/moment";
import {
  SpecificUserForm,
  UserForm,
} from "../../data-parsing/userForms/UserForm";
import { ScrollableDragDropForm } from "../../components/form/DragDropForm";
import { AddUserFormFormTemplate } from "../../data-parsing/userForms/FormTemplate";
import { fileToDataURL } from "../../data-parsing/parseUtils";
import DragDropInput from "../../components/form/DragDropInput";
import API from "../../api/api"
import { useGetMyselfDoctor } from "../myAccount";
import { file } from "jszip";

export default function UserDetails() {
  const { id } = useParams();
  const { user } = useUser(id);

  console.log("user", user);

  //These are table column specifications I guess
  let colDefs = buildColDefs(UserDiet);
  let appointmentColDefs = buildColDefs(UserAppointment);
  let userFormColDefs = buildColDefs(UserForm);

  // Dietas
  const { diets } = useUserDiets(id);

  const { userAppointments, createAppointment, deleteAppointment } =
    useUserAppointments(id);

  let doctorRef = useRef();
  let dateRef = useRef();
  const [doctorId, setDoctorId] = useState();
  const [gender, setGender] = useState(user?.gender);

  const [date, setDate] = useState(0);

  const query = {
    // _id: sessionStorage.getItem("userid"),
    id_usuario: id,
    doctor_id: doctorId,
    first_day: date,
    last_day: parseFloat(date) + 60 * 60 * 24,
  };


  const { forms, createForm, updateForm, deleteForm } = useForms(query.id_usuario);
  console.log("FORMS", forms)

  const { usedHours } = useUsedHours(query);

  const { createMediaPdfFile } = useMediaPdfFile("history", "");

  const [visibleForUser, setVisibleForUser] = useState(false);

  const handleVisibilityChange = (event) => {
    setVisibleForUser(event.target.checked);
    console.log("VISIBLE FOR USER", visibleForUser);
  };

  const handleTabChange = () => {
    setDoctorId(doctorRef.current?.getValue()[0]?.value);
    setDate(dateRef.current?.input?.value);
  };


  //Honestly I don't get why this is being usedd
  useEffect(() => {
    if (user) {
      setGender(user.gender);

    }
  }, [user]);

  const afterSubmit = (newElement, parsedFormData) => {
    console.log("ENTRO afterSubmit");
    console.log("visible para usu", visibleForUser);
    console.log("parsedFormData", parsedFormData);
    console.log("asdbasdapfibo", parsedFormData[0]["pdfFiles"].length);
    console.log("ID AFTERSUBMIT", parsedFormData[0]._id);
    let index = 0;

    console.log("newElement", newElement?._id);
    console.log("entro a while");

    //@alreylz - Bugfix si el nombre del archivo contiene caracteres especiales
    const safeFileName = parsedFormData[0]["pdfFiles"].name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    //This is doing something i guess (I should upload the file here as well)
    fileToDataURL(
      newElement?._id,
      parsedFormData[0]["pdfFiles"],

      safeFileName,
      createMediaPdfFile,
      false,
      visibleForUser,
      "video"
    );

    console.log("newElement ", newElement)
    console.log("parsedFormData ", parsedFormData)

    handleUpload(parsedFormData[0]["pdfFiles"], "history", newElement._id).then((result) => {
      console.log("here I think i uploaded the file now")
      window.location.reload()
    }).catch((err) => {
      console.error(err)
    })



  };

  const refToMyFormField = useRef()
  const refToMyFormFieldName = useRef()







  const { doctorInfo, isFetching, gotError, updateDoctorInfo, updatePassword } =
    useGetMyselfDoctor(sessionStorage.getItem("userid"))



  //Aux state to debug upload of pdf informes
  const [alreylzDoctorId, setAlreylzDoctorId] = useState()



  useEffect(() => {
    if (userAppointments?.length > 0) {
      setAlreylzDoctorId({
        activeCitaDoctorId: userAppointments?.[0].doctor_id,
        activePatientId: userAppointments?.[0].user_id
      })
    }
  }
    , [userAppointments])

  const { informes } = useInformes(id, sessionStorage.getItem("userid"))


  console.log(`
    > User: ${JSON.stringify(user)} \n
    > Dietas : ${JSON.stringify(diets)} \n
    > User Appointments : ${JSON.stringify(userAppointments)} \n
    > Forms: ${JSON.stringify(forms)} \n
    > Doctor Id : ${doctorId} \n
    > Gender ${gender} \n
    > Date: ${date} \n 
    > Query: ${JSON.stringify(query)} \n
    > usedHours : ${JSON.stringify(usedHours)} \n
    Parámetros (de dónde sacarlos)

    ID USUARIO PACIENTE: 6808b91dc1db610712a12144 (query.id_usuario)
  AlreylzDoctor id: ${JSON.stringify(alreylzDoctorId)} // BASE PARA ASIGNAR LOS IDS DE LOS INFORMES
    `)


  console.log(`informes: `, informes)

  return (
    <LeftSideMenu active="users">
      <Breadcrumbs />
      {/* Datos del back :{JSON.stringify(forms)}
      {JSON.stringify(doctorInfo)} */}
      <div id="wrapper">
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <div className="card-box card-tabs m-t-20">
                <h4 className="header-title m-t-0 m-b-30 pull-right">{`PACIENTE ${user?.name}`}</h4>

                <div className="tab-content mt-15">
                  <form className="p-t-5">
                    <div>
                      <h4 className="m-t-5 m-b-0">Datos de Usuario</h4>
                      <hr className="m-t-10" />
                    </div>
                    <div className={"row"}>
                      <CreationFormInput
                        name={"_id"}
                        size={1 / 4}
                        defaultValue={user?.name}
                        inputData={User.name}
                        ref={refToMyFormFieldName}
                      />
                      <CreationFormInput
                        name={"last_name"}
                        size={1 / 4}
                        defaultValue={user?.last_name}
                        inputData={User.last_name}
                        ref={refToMyFormField}
                      />
                      <CreationFormInput
                        name={"prefix"}
                        size={1 / 6}
                        defaultValue={user?.prefix}
                        inputData={User.prefix}
                      />
                      <CreationFormInput
                        name={"telephone_number"}
                        size={1 / 3}
                        defaultValue={user?.telephone_number}
                        inputData={User.telephone_number}
                      />
                      <CreationFormInput
                        name={"age"}
                        size={1 / 4}
                        defaultValue={user?.age}
                        inputData={User.age}
                      />
                      <CreationFormInput
                        name={"gender"}
                        size={1 / 4}
                        defaultValue={gender}
                        inputData={User.gender}
                      />
                      <CreationFormInput
                        name={"height"}
                        size={1 / 4}
                        defaultValue={user?.height}
                        inputData={User.height}
                      />
                      <CreationFormInput
                        name={"weight"}
                        size={1 / 4}
                        defaultValue={user?.weight}
                        inputData={User.weight}
                      />
                      <CreationFormInput
                        name={"email"}
                        size={1 / 1}
                        defaultValue={user?.email}
                        inputData={User.email}
                      />
                      <CreationFormInput
                        name={"avoid_diet_cond"}
                        size={1 / 2}
                        defaultValue={user?.avoid_diet_cond}
                        inputData={User.avoid_diet_cond}
                      />
                      <CreationFormInput
                        name={"aliment_exceptions"}
                        size={1 / 2}
                        defaultValue={user?.aliment_exceptions}
                        inputData={User.aliment_exceptions}
                      />
                      <CreationFormInput
                        name={"avoid_diet_pref"}
                        size={1 / 2}
                        defaultValue={user?.avoid_diet_pref}
                        inputData={User.avoid_diet_pref}
                      />
                      <CreationFormInput
                        name={"food_pref_exclusion"}
                        size={1 / 2}
                        defaultValue={user?.food_pref_exclusion}
                        inputData={User.food_pref_exclusion}
                      />
                      <CreationFormInput
                        name={"version"}
                        size={1 / 3}
                        defaultValue={user?.version}
                        inputData={User.version}
                      />
                      <CreationFormInput
                        name={"connection_timestamp"}
                        size={1 / 3}
                        defaultValue={user?.connection_timestamp}
                        inputData={User.connection_timestamp}
                      />
                      <CreationFormInput
                        name={"unconfirmedSMS"}
                        size={1 / 3}
                        defaultValue={user?.unconfirmedSMS}
                        inputData={User.unconfirmedSMS}
                      />
                      <CreationFormInput
                        name={"activity"}
                        size={1 / 2}
                        defaultValue={user?.activity}
                        inputData={User.activity}
                      />
                      <CreationFormInput
                        name={"favorite_doctors"}
                        size={1 / 2}
                        defaultValue={user?.favorite_doctors}
                        inputData={User.favorite_doctors}
                      />
                      <CreationFormInput
                        name={"plan"}
                        size={1 / 4}
                        defaultValue={user?.plan}
                        inputData={User.plan}
                      />
                      <CreationFormInput
                        name={"plan_validity_start"}
                        size={1 / 4}
                        defaultValue={user?.plan_validity_start}
                        inputData={User.plan_validity_start}
                      />
                      <CreationFormInput
                        name={"plan_validity_until"}
                        size={1 / 4}
                        defaultValue={user?.plan_validity_until}
                        inputData={User.plan_validity_until}
                      />
                      <CreationFormInput
                        name={"munchy_type"}
                        size={1 / 4}
                        defaultValue={user?.munchy_type}
                        inputData={User.munchy_type}
                      />
                    </div>

                    {/*                     <div>
                      <h4 className="m-t-5 m-b-0">Dieta Activa</h4>
                      <hr className="m-t-10" />
                    </div> */}
                    <div className="row">
                      <CreationFormInput
                        name={"active_diet"}
                        size={1 / 2}
                        defaultValue={user?.active_diet}
                        inputData={SpecificUserDetails(user?._id).active_diet}
                      />
                      <CreationFormInput
                        name={"active_diet_date"}
                        size={1 / 2}
                        defaultValue={user?.active_diet_date}
                        inputData={User.active_diet_date}
                      />
                      <CreationFormInput
                        name={"favorite_diets"}
                        size={1 / 1}
                        defaultValue={user?.favorite_diets}
                        inputData={User.favorite_diets}
                      />
                      {/*                       <CreationFormInput
                        name={"active_diet_date_start_meal"}
                        size={1 / 3}
                        defaultValue={user?.active_diet_date_start_meal}
                        inputData={User.active_diet_date_start_meal}
                      /> */}
                      <CreationFormInput
                        name={"diet_complete"}
                        size={1 / 3}
                        defaultValue={user?.diet_complete}
                        inputData={User.diet_complete}
                      />
                      <CreationFormInput
                        name={"diet_complete_global"}
                        size={1 / 3}
                        defaultValue={user?.diet_complete_global}
                        inputData={User.diet_complete_global}
                      />
                      <CreationFormInput
                        name={"diet_complete_programs_global"}
                        size={1 / 3}
                        defaultValue={user?.diet_complete_programs_global}
                        inputData={User.diet_complete_programs_global}
                      />
                      <CreationFormInput
                        name={"diet_success"}
                        size={1 / 2}
                        defaultValue={user?.diet_success}
                        inputData={User.diet_success}
                      />
                      <CreationFormInput
                        name={"diet_success_global"}
                        size={1 / 2}
                        defaultValue={user?.diet_success_global}
                        inputData={User.diet_success_global}

                      />
                    </div>


                    {/* <button
                      type="button"
                      onClick={async () => {
                        window.alert("Should update user")
                        const client = API.instance()

                        user.last_name = refToMyFormField.current.value
                        user.name = refToMyFormFieldName.current.value

                        console.log("updated user", user)
                        console.log(refToMyFormField.current)
                        console.log(refToMyFormField.current.value)
                        window.alert(`${refToMyFormField.current}`)
                        const resp = await client.updateUser(user)
                        console.log(resp)
                        // window.alert(JSON.stringify(resp))

                      }}>Guardar cambios</button> */}

                  </form>
                  <div>
                    <h4 className="m-t-10 m-b-0">Dietas de Usuario</h4>
                    <hr className="m-t-10" />
                  </div>

                  <div className="mr-10 ml-10">
                    <DataTable
                      colDefs={colDefs}
                      data={diets}
                      dataId={"UserDetails"}
                      resizable={true}
                      allowHiddenColumns={false}
                      scrollX={false}
                      className="table table-bordered panel-group"
                    />
                  </div>

                  <div>
                    <h4 className="m-t-10 m-b-0">Citas con MunchFit</h4>
                    <hr className="m-t-10" />
                  </div>
                  <TabbedContent
                    removeContent={false}
                    onTabChange={handleTabChange}
                    tabHeaders={[
                      <button data-toggle="tab" aria-expanded="true">
                        <i className="far fa-eye"></i> LISTAR CITAS
                      </button>,
                      <button data-toggle="tab" aria-expanded="false">
                        <i className="fas fa-plus-circle"></i> NUEVA CITA
                      </button>,
                      <button data-toggle="tab" aria-expanded="false">
                        <i className="fas fa-eye"></i> LISTAR CITAS PASADAS
                      </button>,
                    ]}
                  >
                    <div className="mr-10 ml-10 mt-20">
                      <DataTable
                        colDefs={appointmentColDefs}
                        data={userAppointments?.filter((appointment) => {
                          return (
                            appointment.horas_reservadas >=
                            new Date().getTime() / 1000
                          );
                        })}
                        dataId={"UserAppointments"}
                        resizable={true}
                        allowHiddenColumns={false}
                        scrollX={false}
                        className="table table-bordered panel-group"
                        deleteElement={deleteAppointment}
                      />
                    </div>
                    <div className="fade in ">
                      <div className="row">
                        <CreationForm createFunction={createAppointment}>
                          <div className="pt-5">
                            <CreationFormInput
                              name={"doctor_id"}
                              size={1 / 2}
                              onChange={(e) => {
                                setDoctorId(e.value);
                              }}
                              inputData={UserAppointment.doctor_id}
                              ref={doctorRef}
                            />
                            <CreationFormInput
                              name={"horas_reservadas"}
                              size={1 / 2}
                              onChange={(e) => {
                                setDate(
                                  moment(e, "DD/MM/YYYY").toDate().getTime() /
                                  1000
                                );
                              }}
                              inputData={UserAppointment.horas_reservadas}
                              ref={dateRef}
                            />
                            <CreationFormInput
                              name={"hora_cita"}
                              size={1 / 2}
                              inputData={
                                SpecificUserAppointment(usedHours).hora_cita
                              }
                            />
                          </div>

                          <input
                            type={"hidden"}
                            name={"id_usuario"}
                            value={id}
                          />

                          <div className="col-sm-12">
                            <button className="btn btn-rounded btn-purple m-t-20 ml-10">
                              <i className="far fa-save"></i> Guardar Sesión
                            </button>
                          </div>
                        </CreationForm>
                      </div>
                    </div>

                    <div className="mr-10 ml-10 mt-20">
                      <DataTable
                        colDefs={appointmentColDefs}
                        data={userAppointments?.filter((appointment) => {
                          return (
                            appointment.horas_reservadas <
                            new Date().getTime() / 1000
                          );
                        })}
                        dataId={"OldUserAppointments"}
                        resizable={true}
                        allowHiddenColumns={false}
                        scrollX={false}
                        className="table table-bordered panel-group"
                        deleteElement={deleteAppointment}
                      />
                    </div>
                  </TabbedContent>

                  <div>
                    <h4 className="m-t-10 m-b-0">Informes</h4>
                    <hr className="m-t-10" />
                  </div>
                  <TabbedContent
                    removeContent={false}
                    onTabChange={handleTabChange}
                    tabHeaders={[
                      <button data-toggle="tab" aria-expanded="true">
                        <i className="far fa-eye"></i> LISTAR INFORMES
                      </button>,
                      <button data-toggle="tab" aria-expanded="false">
                        <i className="fas fa-plus-circle"></i> NUEVO INFORME
                      </button>,
                    ]}
                  >
                    <div className="mr-10 ml-10 mt-20">
                      <DataTable
                        colDefs={
                          // userFormColDefs ??
                          userFormColDefs.map((elem) => {
                            console.log(`Elem ${JSON.stringify(elem)}`)

                            if (elem.name !== "session")
                              return elem


                            return {
                              "name": "session",
                              "type": "select",

                              "metadata": {
                                "visibleName": "Sesión",
                                "type": "select",
                                "optionsMapping": {

                                  "source": "inline",
                                  "options": SpecificUserForm(id).session.optionsMapping.options
                                }
                              }
                            }
                          }

                          )}
                        data={forms?.map((dataRow) => {

                          console.log(`data Row ${JSON.stringify(dataRow)}`)
                          const copyOfRow = structuredClone(dataRow)

                          //crear un botón para la previsualización
                          if (dataRow.url.length > 0) {
                            copyOfRow.url = {
                              onClick: () => getInformePDF(copyOfRow?._id,
                                dataRow.url?.[0]
                                // "ejemplo8.pdf"
                              ),
                              label: `Ver pdf ${copyOfRow.url[0]}`
                            }
                          }


                          return copyOfRow

                        })}
                        dataId={"UserForms"}
                        resizable={true}
                        allowHiddenColumns={true}
                        scrollX={false}
                        className="table table-bordered panel-group"
                        deleteElement={(id) => {
                          console.log("trying to delete an appointment", id)
                          deleteForm(id).then(() => {
                            window.location.reload()
                          })
                        }}
                        // This is not properly working 
                        editElement={updateForm}
                      />
                    </div>

                    <div className="row">


                      <CreationForm
                        createFunction={createForm}
                        afterSubmit={afterSubmit}
                      >
                        <CreationFormInput
                          name={"session"}
                          size={1 / 2}
                          style={{ marginTop: "5px" }}
                          inputData={SpecificUserForm(id)?.session}
                          onChange={(thing, value) => {
                            console.log(`CHANGED SESSION ${JSON.stringify(thing)} , ${JSON.stringify(value)}`)
                            const theAppointment = userAppointments.filter((appointment) => {

                              console.log("Appointment", appointment)
                              return (appointment._id === thing.value)
                            })[0]
                            console.log("APPOINTMENT CHANGED", theAppointment)
                            setAlreylzDoctorId({
                              activeCitaDoctorId: theAppointment.doctor_id,
                              activePatientId: theAppointment.user_id
                            }

                            )
                          }}
                        />
                        <CreationFormTemplate
                          formTemplate={AddUserFormFormTemplate}
                          dataTemplate={UserForm}
                        />

                        {/* Paciente */}
                        <input type={"hidden"} name={"patient_id"} value={id} />
                        {/* Nutricionista */}
                        <input type={"hidden"} name={"doctor_id"} value={alreylzDoctorId?.activeCitaDoctorId} />

                        <input type={"hidden"} name={"user_id"} value={sessionStorage.getItem("userid")} />
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Adjuntar archivos</label>
                            <DragDropInput
                              fileTypes={["pdf"]}
                              style={{ height: "350px" }}
                              name={"pdfFiles"}
                            />
                          </div>
                        </div>

                        <div className="col-sm-12">
                          <div className="form-group">

                            <div className="mb-3">
                              <label style={{ marginTop: "5px", marginBottom: "10px" }}>
                                <input
                                  type="checkbox"
                                  name="pdfVisibility"
                                  className="mr-2"
                                  name={"visible_for_user"}
                                  value={visibleForUser}
                                  onChange={handleVisibilityChange}
                                />
                                <span style={{ marginLeft: "8px" }}>Visible para el usuario</span>
                              </label>
                            </div>

                            <div>
                              <button className="btn btn-rounded btn-purple">
                                <i className="far fa-save"></i> Guardar Informe
                              </button>
                            </div>
                          </div>
                        </div>

                      </CreationForm>
                    </div>
                  </TabbedContent>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </LeftSideMenu>
  );
}









const baseUrl = "https://backend.munchfit.app";





//Con esto puedo sacar los archivos pdf
export async function getInformePDF(history_id,
  fileUrl = "Catalogo_Grillo_HWT550-HWT600-HWT700.pdf") {

  // debugger
  console.log(`Informes PDF hid : ${history_id} fileUrl: ${fileUrl}`)


  // Version 1 ) Displaying using the binary data provided directly by an endpoint
  // This is forges an url where the file should be directly accesible as 'application/pdf'
  const doneDisplaying = await fetchInformeAndDisplayFromDirectURl(history_id, fileUrl)

  // DELETEME
  // Version 2) Getting data as base64 and then convert it to something displayable
  // This way i am getting directly the base64 string i could display
  // const pdfInBase64 = await forceLocateB64FileWithFinder("history", history_id, fileUrl)

  // if (pdfInBase64.base64){
  //   const doneDisplayingV2 = await openBase64PdfAsSeparateTab(pdfInBase64.base64)
  // }
  // try {
  //   const finderBlob = base64ToBlob(pdfInBase64.base64)
  //   console.log("BLOB ALEX",)
  //   openBlobInNewTab(finderBlob)
  // }
  // catch (err) {



  // }




}









async function fetchInformeAndDisplayFromDirectURl(history_id, fileUrl) {

  const finalURL = `${baseUrl}/private/history/${history_id}/${encodeURIComponent(fileUrl)}`;

  const tab = window.open('', '_blank');

  tab.document.write(`
    <!doctype html>
    <title>${fileUrl}</title>
    <style>
      html,body { height:100%; margin:0 auto;   font-family:sans-serif;  }
    </style>
    <p>Cargando PDF…</p>
  `);




  try {
    // --- Fetch the file ---
    const res = await fetch(finalURL, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Token: sessionStorage.getItem('token'),
        Userid: sessionStorage.getItem('userid'),
        version: 999999,
        Accept: 'application/pdf'
      }
    });

    //--- Check response validity ---
    if (!res.ok) throw new Error(`HTTP ${res.status} - ${res.statusText}`);

    const contentType = res.headers.get('content-type') || '';
    if (!contentType.includes('pdf')) {
      throw new Error(`Invalid content-type: ${contentType}`);
    }


    const blob = await res.blob();

    if (!blob || blob.size === 0) {
      throw new Error('Empty or invalid PDF blob');
    }

    const buffer = await blob.slice(0, 200).arrayBuffer();
    console.log(new TextDecoder().decode(buffer));

    // --- Check magic number (%PDF-) ---
    const headBytes = new Uint8Array(await blob.slice(0, 5).arrayBuffer());
    const magic = String.fromCharCode(...headBytes);


    let fixedBlob = blob;

    if (!magic.startsWith('%PDF-')) {
      console.warn('⚠️ Missing %PDF- header. Attempting to patch manually...');

      // Decode existing bytes into text (if needed)
      const arrayBuffer = await blob.arrayBuffer();
      const pdfBytes = new Uint8Array(arrayBuffer);

      // Add the %PDF-1.4 header manually at the start
      const prefix = new TextEncoder().encode('%PDF-1.4\n');
      const combined = new Uint8Array(prefix.length + pdfBytes.length);
      combined.set(prefix, 0);
      combined.set(pdfBytes, prefix.length);

      fixedBlob = new Blob([combined], { type: 'application/pdf' });
    }
    // --- Try blob URL embedding ---
    const blobUrl = URL.createObjectURL(fixedBlob);
    try {
      tab.document.body.innerHTML = `
        <embed src="${blobUrl}" type="application/pdf" style="width:100%;height:100%">
      `;
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
      return;
    } catch (embedErr) {
      console.warn('Embed failed, trying DataURL fallback...', embedErr);
    }

    // --- Safari/iOS fallback using FileReader ---
    try {
      const reader = new FileReader();
      reader.onloadend = () => {
        tab.document.body.innerHTML = `
          <embed src="${reader.result}" type="application/pdf" style="width:100%;height:100%">
        `;
      };
      reader.readAsDataURL(fixedBlob);
      return;
    } catch (dataUrlErr) {
      console.warn('DataURL fallback failed', dataUrlErr);
    }

    // --- Final fallback: direct download ---
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileUrl;
    a.click();
    tab.close();
  } catch (err) {
    console.error('❌ Failed to open PDF:', err);
    try {
      tab.document.body.innerHTML = `
        <p style="color:red; padding:2em;">
          Error cargando PDF.<br>
          <small>${err.message}</small>
        </p>`;
    } catch { }
  }
}











function openBlobInNewTab(blob) {
  const url = URL.createObjectURL(blob);
  const tab = window.open('', '_blank');       // call from a user click handler
  if (!tab) { alert('Enable pop-ups'); return; }

  // write a simple viewer shell and embed the blob URL
  tab.document.write(`<!doctype html><title>File</title>
    <style>html,body{height:100%;margin:0}</style>
    <embed src="${url}" type="${blob.type || 'application/octet-stream'}"
           style="width:100%;height:100%">`);

  // free the URL later
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

async function blobFromDataUri(dataUri) {
  // avoids atob, padding, URL-safe variants, etc.
  const res = await fetch(dataUri);
  return await res.blob();
}



async function forceLocateB64FileWithFinder(folder, resourceId, matchFileName) {

  const apiClient = API.instance()
  const response = await apiClient.findMedia(folder, resourceId)
  window.alert(`found  : ${JSON.stringify(Object.keys(response))}`)

  console.log(`Searching media ${folder}/${resourceId}`)
  console.dir(response)

  let endFile = null


  Object.entries(response).forEach(([fileName, base64dataOrSomething]) => {

    if (matchFileName
      !== fileName)
      return endFile
    const cleanBase64 = base64dataOrSomething.replace(/^base64/, "");
    //get what type of file it is
    const type =
      ([".jpg", ".jpeg", ".png", ".svg"].some(ext =>
        fileName.toLowerCase().endsWith(ext)
      )) ? "Image" :
        ([".mp4"].some(ext =>
          fileName.toLowerCase().endsWith(ext)
        )) ? "Video" :
          (["pdf"].some(ext =>
            fileName.toLowerCase().endsWith(ext)
          )) ? "Pdf" : "Unknown"



    endFile = {
      name: fileName,
      type,
      base64:
        type === "Image"
          ? `data:image/png;base64,${cleanBase64}`
          : type === "Pdf"
            ? `data:application/pdf;base64,${cleanBase64}`
            : type === "Video"
              ? `data:video/mp4;base64,${cleanBase64}`
              : null,

    }
  })
  return endFile





}



function normalizePdfBase64(b64OrDataUrl) {
  let s = (b64OrDataUrl || '').trim();

  // Already a data URL?
  if (/^data:application\/pdf;base64,/i.test(s)) return s;

  // Starts with "base64," or weird prefix? strip it
  s = s.replace(/^base64,/i, '');

  // Remove whitespace/zero-width cruft
  s = s.replace(/[\s\u200B-\u200D\uFEFF]/g, '');

  // URL-safe → standard base64
  s = s.replace(/-/g, '+').replace(/_/g, '/');

  // Keep only legal base64 chars
  s = s.replace(/[^A-Za-z0-9+/=]/g, '');

  // Pad to length % 4 === 0
  const pad = s.length % 4;
  if (pad) s += '='.repeat(4 - pad);

  return `data:application/pdf;base64,${s}`;
}

async function openBase64PdfAsSeparateTab(b64OrDataUrl, filename = 'document.pdf') {
  // Open tab immediately (avoid popup blockers)
  const tab = window.open('', '_blank');
  if (!tab) {
    alert('Enable pop-ups to view the PDF.');
    return;
  }
  tab.document.write(`<!doctype html><title>${filename} - b64</title>
    <style>html,body{height:100%;margin:0 auto; }</style>
    <p>Cargando PDF…</p>`);

  try {
    const dataUrl = normalizePdfBase64(b64OrDataUrl);

    // Convert data URL → Blob without atob
    const blob = await (await fetch(dataUrl)).blob();
    if (!blob.size) throw new Error('Empty PDF');

    // Optional sanity: check magic "%PDF-"
    const head = new Uint8Array(await blob.slice(0, 5).arrayBuffer());
    const magic = String.fromCharCode(...head);
    if (!magic.startsWith('%PDF-')) {
      console.warn('PDF header missing, but trying to render anyway…');
    }

    const url = URL.createObjectURL(blob);
    tab.document.body.innerHTML =
      `<embed src="${url}" type="application/pdf" style="width:100%;height:100%">`;
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (e) {
    console.error('Failed to open PDF:', e);
    try {
      tab.document.body.innerHTML = `<p style="color:red;padding:2em">
        Error cargando PDF<br><small>${e.message}</small></p>`;
    } catch { }
  }
}










function base64ToBlob(base64, mime = 'application/pdf') {

  // 1) Strip known prefixes (data:… or leading "base64")
  let clean = base64.trim()
    .replace(/^base64,/i, '')
    .replace(/^data:application\/pdf;base64,/i, '');

  // 2) Remove whitespace + zero-width junk some servers add
  clean = clean.replace(/[\s\u200B-\u200D\uFEFF]/g, '');

  // 3) Convert URL-safe base64 → standard (if present)
  clean = clean.replace(/-/g, '+').replace(/_/g, '/');

  // 4) Keep only valid base64 chars; this also drops any accidental quotes
  clean = clean.replace(/[^A-Za-z0-9+/=]/g, '');

  // 5) Fix padding to multiple of 4
  const pad = clean.length % 4;
  if (pad) clean += '='.repeat(4 - pad);
  // Decode clean Base64 into binary
  const binary = atob(clean);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return new Blob([bytes], { type: mime });
}






export const useInformes = (patient_id, doctor_id) => {

  const [informes, setInformes] = useState()

  useEffect(() => {

    const fetchInformes = async (pat_id, doctor_id) => {


      const requestOptions = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({

          patient_id: pat_id,
          doctor_id: doctor_id //?? "685919276216e85294c81530"
          ,
          //Always required for authentication
          user_id: sessionStorage.getItem("userid"),
          token: sessionStorage.getItem("token"),
          android_id: 0,
        })
      };


      //Doing the fecth
      const response = await fetch(
        baseUrl + "/saveWebUser/getHistory",
        requestOptions
      );


      const parsedBody = await response.json();

      if (!response.ok)
        throw new Error(`Error in the request fetching citas. Server says : ${JSON.stringify(parsedBody)}`)
      return parsedBody

    }

    //Realizo de verdad fetching
    fetchInformes(patient_id, doctor_id)
      .then((responseContent) => {
        console.log("Response citas",
          responseContent)
        setInformes(responseContent)
      }).catch((err) => {
        console.error("Error fetching informes: ", err.message)
      })
  },
    [patient_id, doctor_id]
  )



  return { informes }


}




const handleUpload = async (
  file,
  folder,
  id) => {


  if (!file) {
    alert("Please select a file first.");
    return;
  }


  const apiClient = API.instance()


  //Convert to base64 representation
  // const fileb64 = fileToBase64(file)
  const fileName = file.name
  const safeFileName = fileName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");


  let responseWithConversionJSON;


  //Si es un archivo de imagen funciona
  if (!file.name.endsWith(".pdf"))
    responseWithConversionJSON = await apiClient.createMediaSOSWithBase64(
      folder,
      id,
      file,
      safeFileName,
      false,
      "Image"
    )
  //Everything that is not an image is send as "video" type for some reason
  else {


    responseWithConversionJSON = await apiClient.createMediaSOSWithBase64(
      folder,
      id,
      file,
      safeFileName,
      false,
      "Video"
    )

  }
  // window.alert(`createMediaSOSWithBase64 : ${JSON.stringify(responseWithConversionJSON)}`)
  //Apparently the name is auto generated in the back xD
  console.log(`UPLOADED NAME: ${responseWithConversionJSON.data}`)

  return responseWithConversionJSON

}